export default __webpack_public_path__ + "static/media/chevron-down.36ef4c52.svg";